export const currentP5Version = '2.3.4';

// Generated from https://www.npmjs.com/package/p5?activeTab=versions
// Run this in the console:
// JSON.stringify([...document.querySelectorAll('._132722c7')].map(n => n.innerText), null, 2)
// TODO: use their API for this to grab these at build time?
export const p5Versions = [
  { version: '2.3.4', label: '(Latest)' },
  '2.3.2',
  '2.3.2',
  '2.3.1',
  '2.3.0',
  '2.2.3',
  '2.2.2',
  '2.2.1',
  '2.2.0',
  '2.1.2',
  '2.1.1',
  '2.0.5',
  '2.0.4',
  '2.0.3',
  '2.0.2',
  '2.0.1',
  '2.0.0',
  { version: '1.11.13', label: '(Not Maintained)' },
  '1.11.12',
  '1.11.11',
  '1.11.10',
  '1.11.9',
  '1.11.8',
  '1.11.7',
  '1.11.6',
  '1.11.5',
  '1.11.4',
  '1.11.3',
  '1.11.2',
  '1.11.1',
  '1.11.0',
  '1.10.0',
  '1.9.4',
  '1.9.3',
  '1.9.2',
  '1.9.1',
  '1.9.0',
  '1.8.0',
  '1.7.0',
  '1.6.0',
  '1.5.0',
  '1.4.2',
  '1.4.1',
  '1.4.0',
  '1.3.1',
  '1.3.0',
  '1.2.0',
  '1.1.9',
  '1.1.8',
  '1.1.7',
  '1.1.5',
  '1.1.4',
  '1.1.3',
  '1.1.2',
  '1.1.1',
  '1.1.0',
  '1.0.0',
  '0.10.2',
  '0.10.1',
  '0.10.0',
  '0.9.0',
  '0.8.0',
  '0.7.3',
  '0.7.2',
  '0.7.1',
  '0.7.0',
  '0.6.1',
  '0.6.0',
  '0.5.16',
  '0.5.15',
  '0.5.14',
  '0.5.13',
  '0.5.12',
  '0.5.11',
  '0.5.10',
  '0.5.9',
  '0.5.8',
  '0.5.7',
  '0.5.6',
  '0.5.5',
  '0.5.4',
  '0.5.3',
  '0.5.2',
  '0.5.1',
  '0.5.0',
  '0.4.24',
  '0.4.23',
  '0.4.22',
  '0.4.21',
  '0.4.20',
  '0.4.19',
  '0.4.18',
  '0.4.17',
  '0.4.16',
  '0.4.15',
  '0.4.14',
  '0.4.13',
  '0.4.12',
  '0.4.11',
  '0.4.10',
  '0.4.9',
  '0.4.8',
  '0.4.7',
  '0.4.6',
  '0.4.5',
  '0.4.4',
  '0.4.3',
  '0.4.2',
  '0.4.1',
  '0.4.0',
  '0.3.16',
  '0.3.15',
  '0.3.14',
  '0.3.13',
  '0.3.12',
  '0.3.11',
  '0.3.10',
  '0.3.9',
  '0.3.8',
  '0.3.7',
  '0.3.6',
  '0.3.5',
  '0.3.4',
  '0.3.3',
  '0.3.2',
  '0.3.1',
  '0.3.0',
  '0.2.23',
  '0.2.22',
  '0.2.21',
  '0.2.20',
  '0.2.19',
  '0.2.18',
  '0.2.17',
  '0.2.16',
  '0.2.15',
  '0.2.14',
  '0.2.13',
  '0.2.12',
  '0.2.11',
  '0.2.10',
  '0.2.9',
  '0.2.8',
  '0.2.7',
  '0.2.6',
  '0.2.5',
  '0.2.4',
  '0.2.3',
  '0.2.2',
  '0.2.1'
];
